import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'state/hooks'

import { updateIslandDepositsUSD } from './reducer'

// return a value and a setter for the user's total island deposits as separate functions
export function useKodiakIslandTotalUserDeposit(): number {
  const allDeposits = useAppSelector((state) => state.userPositionData.kodiakIslandUserDepositUSD)
  return Object.values(allDeposits).reduce((sum, value) => sum + (Number(value) || 0), 0)
}

export function useUpdateUserIslandDepositUSD(): (islandId: string | undefined, amountUSD: number) => void {
  const dispatch = useAppDispatch()
  const kodiakIslandUserDepositUSD = useAppSelector((state) => state.userPositionData.kodiakIslandUserDepositUSD)
  return useCallback(
    (islandId: string | undefined, amountUSD: number) => {
      if (!islandId || !amountUSD) return
      dispatch(
        updateIslandDepositsUSD({
          islandId,
          updatedAmount: amountUSD,
        })
      )
    },
    [dispatch, kodiakIslandUserDepositUSD]
  )
}
